/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], function( ) {

	/**
	 * @class CustomGroupActionAPI
	 * @hideconstructor
	 * @classdesc Performance feature to contain all widget performance related information.
	 * For now contains only IPA related logic, but that might change in the future.
	 * Verify simple feature, for now just holds a state variable with a boolean
	 * that tells if the IPA feature is active or not. In the future will get more complicated.
	 * 
	 * A brief description of IPA (Interactive Performance Assistant):
	 * Feature to collect performance detail information on demand across multiple-servers,
	 * cross-processes to help trouble shooting Cognos analytic performance issues.
	 */
	class PerformanceAPI {

		/**
		 * @function PerformanceAPI#activateIPA
		 * @description activate the IPA feature
		 */
		activateIPA(){}

		/**
		 * @function PerformanceAPI#deactivateIPA
		 * @description activate the IPA feature
		 */
		deactivateIPA(){}

		/**
		 * @function PerformanceAPI#isIPAActive
		 * @description activate the IPA feature
		 */
		isIPAActive(){}
	}

	return PerformanceAPI;

});